module.exports = __webpack_public_path__ + "img/hetong1.15f02ce1.png";